import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { strapiGet, strapiPost, strapiPut } from '@/lib/strapi'

export interface ApiKey {
  id: number
  documentId: string
  bookosId: string
  displaySuffix: string
  active: boolean
  createdAt: string
}

export function useApiKeys() {
  return useQuery({
    queryKey: ['api-keys'],
    queryFn: () => strapiGet<ApiKey[]>('/api/api-keys'),
    staleTime: 60_000,
  })
}

export function useGenerateApiKey() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => strapiPost<{ plainKey: string; displaySuffix: string }>('/api/api-keys/generate', {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['api-keys'] }),
  })
}

export function useRevokeApiKey() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (documentId: string) => strapiPut(`/api/api-keys/${documentId}/revoke`, {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['api-keys'] }),
  })
}
